export const LANDING_PAGE_CTA_TEXT = 'landingPageCTAText';
export const CHECKOUT_PAGE_CTA_TEXT = 'checkoutPageCTAText';
export const CHECKOUT_PAGE_TITLE_TEXT = 'checkoutPageTitleText';
export const NEW_CONSENT_FLOW = 'isNewConsentFlow';
